
<template>
  <div class="contenido">
    <div class="ban">
      <div class="banW">
        <img src="@/assets/images/banG.jpg" alt="Line Magnetic" />
      </div>
    </div>

    <div class="limitado">
      <div class="texto">
                <p>Line Magnetic zostało założone w 2005 roku przez dwóch braci - audiofilów z pasją do elektroniki
                    lampowej,
                    a w szczególności do legendarnych amerykańskich osiągnięć z lat 50. XX wieku.</p>

                <p>Wszystkie produkty Line Magnetic są wynikiem pracy zespołu doświadczonych inżynierów audiofilów.
                    Firma
                    posiada dwie fabryki, w których wszystkie produkty są montowane metodą "point-to-point" czyli ręcznie wykonywanym, tradycyjnym montażem przestrzennym na łączówkach.</p>

                <p>Asortyment Line Magnetic obejmuje wzmacniacze, przedwzmacniacze, odtwarzacze CD, przetworniki
                    cyfrowo-analogowe (DAC) i głośniki. Każdy produkt charakteryzuje się wyjątkową jakością wykonania i
                    bardzo wyrazistą osobowością, zawsze nawiązującą do sprawdzonych schematów i legendarnych lamp lub
                    głośników.</p>

            </div>
    </div>

    <div class="ban2">
      <div class="banD">&nbsp;</div>
    </div>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'

useHead({
  title: 'Line Magnetic – pasja do dzwięku',
  meta: [
    {
      name: 'description',
      content: 'Line Magnetic - Wzmacniacze lampowe inspirowane legendarnymi amerykańskimi konstrukcjami z lat 50. XX wieku.'
    },
    {
      property: 'og:title',
      content: 'Line Magnetic – pasja do dźwięku'
    },
    {
      property: 'og:description',
      content: 'Line Magnetic - Wzmacniacze lampowe inspirowane legendarnymi amerykańskimi konstrukcjami z lat 50. XX wieku.'
    }
  ]
})
</script>

